import * as notificationTypes from '../../consts/app/notificationTypes';
import languageService from '../../services/localization/languageService';
import helpers from '../../utils/helpers';

export const SET_IS_APP_LOADING = 'app/global/SET_IS_APP_LOADING';
export const SET_IS_LOADER_VISIBLE = 'app/global/SET_IS_LOADER_VISIBLE';
export const SET_IS_BLUETOOTH_AVAILABLE = 'app/global/SET_IS_BLUETOOTH_AVAILABLE';
export const SET_NOTIFICATION = 'app/global/SET_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'app/global/REMOVE_NOTIFICATION';
export const REMOVE_NOTIFICATION_TYPE = 'app/global/REMOVE_NOTIFICATION_TYPE';
export const SET_LAYOUT = 'app/global/layout/SET_LAYOUT';
export const HIDE_ALL_LOADERS = 'app/global/HIDE_ALL_LOADERS';
export const SET_IS_NETWORK_ONLINE = 'app/global/SET_IS_NETWORK_ONLINE';
export const LOGOUT_CLEAR_DATA = 'app/global/LOGOUT_CLEAR_DATA';
export const SET_IS_RECONNECT_GUIDE_AVAILABLE = 'app/global/SET_IS_RECONNECT_GUIDE_AVAILABLE';
export const SET_IS_START_AUTO_SYNC = 'app/global/SET_IS_START_AUTO_SYNC';
export const SET_SCP_CHECK_IN_PROGRESS = 'app/global/SET_SCP_CHECK_IN_PROGRESS';
export const SET_LANGUAGE_CODE = 'app/global/SET_LANGUAGE_CODE';
export const SET_IS_FWU_PAGE = 'app/global/SET_IS_FWU_PAGE';
export const SET_ERROR_PAGE_TYPE = 'app/global/SET_ERROR_PAGE_TYPE';
export const CLEAR_ERROR_PAGE_TYPE = 'app/global/CLEAR_ERROR_PAGE_TYPE';

export default function reducer(
    state = {
        isAppLoading: true,
        loaders: [],
        errorPageType: undefined,
        notifications: [],
        isBluetoothAvailable: undefined,
        isReconnectGuideEnabled: true,
        isStartAutoSync: false,
        isNetworkOnline: true,
        isScpCheckInProgress: false,
        languageCode: languageService.getInitialLanguageCode(),
        isFwuPage: false,
    },
    action
) {
    switch (action.type) {
        case SET_IS_APP_LOADING: {
            const isAppLoading = action.payload;

            return {...state, isAppLoading};
        }
        case SET_IS_LOADER_VISIBLE: {
            const {name, text, isVisible, isTransparent} = action.payload;
            const {loaders} = state;
            let loadersNew = [...loaders];

            if (isVisible) {
                loadersNew.push({name, text, isTransparent});
            } else {
                loadersNew = loaders.filter((e) => e.name !== name);
            }

            return {...state, loaders: loadersNew};
        }
        case SET_IS_BLUETOOTH_AVAILABLE: {
            const isBluetoothAvailable = action.payload;

            return {...state, isBluetoothAvailable};
        }
        case SET_NOTIFICATION: {
            const {type, textKey, textFormatValues, testId, notificationType, autoFocus, customId} = action.payload;
            const {notifications} = state;
            const notificationsNew = [...notifications];

            if (notificationsNew.some((el) => el.textKey === textKey)) return state;

            const notification = {
                notificationId: customId ? customId : helpers.guid(),
                type,
                textKey,
                textFormatValues,
                testId,
                notificationType,
                autoFocus,
            };

            notificationsNew.push(notification);

            return {...state, notifications: notificationsNew};
        }
        case REMOVE_NOTIFICATION: {
            const {notificationId} = action.payload;
            const {notifications} = state;
            const notificationsNew = notifications.filter(
                (notification) => notification.notificationId !== notificationId
            );

            return {...state, notifications: notificationsNew};
        }
        case REMOVE_NOTIFICATION_TYPE: {
            const {notificationType} = action.payload;
            const {notifications} = state;
            const notificationsNew = notifications.filter(
                (notification) => notification.notificationType !== notificationType
            );

            return {...state, notifications: notificationsNew};
        }
        case HIDE_ALL_LOADERS: {
            return {...state, loaders: []};
        }
        case SET_LAYOUT: {
            const layout = action.payload;

            return {...state, layout};
        }
        case SET_IS_NETWORK_ONLINE: {
            return {
                ...state,
                isNetworkOnline: action.payload,
            };
        }
        case LOGOUT_CLEAR_DATA: {
            return {
                ...state,
                isAppLoading: false,
            };
        }
        case SET_IS_RECONNECT_GUIDE_AVAILABLE: {
            return {
                ...state,
                isReconnectGuideEnabled: action.payload,
            };
        }
        case SET_IS_START_AUTO_SYNC: {
            return {
                ...state,
                isStartAutoSync: action.payload,
            };
        }
        case SET_SCP_CHECK_IN_PROGRESS: {
            return {
                ...state,
                isScpCheckInProgress: action.payload,
            };
        }
        case SET_LANGUAGE_CODE: {
            return {
                ...state,
                languageCode: action.payload,
            };
        }
        case SET_IS_FWU_PAGE: {
            return {
                ...state,
                isFwuPage: action.payload,
            };
        }
        case SET_ERROR_PAGE_TYPE: {
            const {errorPageType} = state;

            if (errorPageType) return state;

            return {
                ...state,
                errorPageType: action.payload,
            };
        }
        case CLEAR_ERROR_PAGE_TYPE: {
            return {
                ...state,
                errorPageType: undefined,
            };
        }
        default:
            return state;
    }
}

export const setIsAppLoaded = () => ({
    type: SET_IS_APP_LOADING,
    payload: false,
});

const setNotification = (props) => {
    const {textKey, textFormatValues, type, testId, notificationType, autoFocus, customId} = props;

    return {
        type: SET_NOTIFICATION,
        payload: {textKey, textFormatValues, type, testId, notificationType, autoFocus, customId},
    };
};

export const setLayout = (layout) => ({type: SET_LAYOUT, payload: layout});
export const setNotificationSuccess = ({textKey, textFormatValues, testId, notificationType, autoFocus, customId}) =>
    setNotification({
        textKey,
        textFormatValues,
        type: notificationTypes.SUCCESS,
        testId,
        notificationType,
        autoFocus,
        customId,
    });
export const setNotificationFailed = ({textKey, testId, customId}) =>
    setNotification({
        textKey,
        type: notificationTypes.FAILED,
        testId,
        customId,
    });
export const setNotificationInfo = ({textKey, textFormatValues, testId, notificationType, customId}) =>
    setNotification({textKey, textFormatValues, type: notificationTypes.INFO, testId, notificationType, customId});

export const removeNotification = (notificationId) => ({
    type: REMOVE_NOTIFICATION,
    payload: {notificationId},
});

export const removeNotificationType = (notificationType) => ({
    type: REMOVE_NOTIFICATION_TYPE,
    payload: {notificationType},
});

export const hideAllLoaders = () => ({type: HIDE_ALL_LOADERS});

export const logoutClearData = () => ({type: LOGOUT_CLEAR_DATA});
export const setIsReconnectGuideAvailable = (data) => ({type: SET_IS_RECONNECT_GUIDE_AVAILABLE, payload: data});
export const setIsStartAutoSync = (data) => ({type: SET_IS_START_AUTO_SYNC, payload: data});
export const setScpCheckInProgress = (data) => ({type: SET_SCP_CHECK_IN_PROGRESS, payload: data});

export const showLoader = (props) => {
    const name = typeof props === 'string' ? props : props?.name;
    const {text, isTransparent} = props || {};

    return setIsLoaderVisible({name, text, isVisible: true, isTransparent});
};

export const hideLoader = (name) => {
    return setIsLoaderVisible({name, isVisible: false});
};

const DEFAULT_LOADER_NAME = 'default';

export const setIsLoaderVisible = ({name = DEFAULT_LOADER_NAME, text, isVisible, isTransparent}) => {
    return {type: SET_IS_LOADER_VISIBLE, payload: {name, text, isVisible, isTransparent}};
};

export const setIsNetworkOnline = (data) => ({type: SET_IS_NETWORK_ONLINE, payload: data});
export const setIsBluetoothAvailable = (data) => ({type: SET_IS_BLUETOOTH_AVAILABLE, payload: data});
export const setLanguageCode = (data) => ({type: SET_LANGUAGE_CODE, payload: data});
export const setIsFwuPage = (data) => ({type: SET_IS_FWU_PAGE, payload: data});

export const setErrorPageType = (data) => ({type: SET_ERROR_PAGE_TYPE, payload: data});
export const clearErrorPageType = () => ({type: CLEAR_ERROR_PAGE_TYPE});
